<template>
  <div class="space-top-desktop">
    <h1 style="text-align: center">{{ content.grades.apresentacao_titulo }}</h1>
    <b-row style="margin-top: 50px; align-items: center; justify-content: center">
      <b-col sm="12" md="6">
        <img src="@/assets/images/img_grade2.jpg" class="img-fluid w-100" />
      </b-col>
      <b-col sm="12" md="6">
        <p class="apresentacao-texto" style="text-align: left;">{{ content.grades.apresentacao_texto }}</p>
      </b-col>
    </b-row>
    <b-row class="apresentacao-lastpic mt-5">
      <b-col sm="12" md="6" class="apresentacao-lastpic">
        <img src="@/assets/images/img_grade3.jpg" class="img-fluid w-100" />
      </b-col>
      <b-col sm="12" md="6" class="apresentacao-lastpic">
        <img src="@/assets/images/img_grade4.jpg" class="img-fluid w-100" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
// Json Content
import json from "../../assets/content.json";
export default {
  name: "Apresentacao",
  data() {
    return {
      content: json,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_standard.scss";
.apresentacao-texto {
  text-align: left;

  @media (max-width: 768px) {
    margin-top: 50px;
  }
}

.apresentacao-lastpic {
  margin-top: 50px;
}

img {
  box-shadow: 10px -10px 0px $primary;
}
</style>
